import { Injectable } from '@angular/core'
import { ApiService } from './api.service'
import { BehaviorSubject, Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

export interface ReleaseDetails {
  sourceDelegateVersion: number
  targetDelegateVersion: number
  description: string
}

@Injectable({
  providedIn: 'root',
})
export class ReleaseDetailsService {
  private releaseDetailsStore$ = new BehaviorSubject<ReleaseDetails[] | null>(null)
  constructor(private apiService: ApiService) {}

  /**
   *
   * IMPORTANT: This array contains the details of features released in various versions of the access templates.
   * It's used to articulate for customers what features they'll see light up if they update their access
   * templates.  With each major release that updates the access templates on the server, we need to also update
   * this list for customers.
   * @returns
   */
  fetchReleaseDetails(): Observable<ReleaseDetails[]> {
    return this.apiService.getReleaseDetails().pipe(tap((details) => this.releaseDetailsStore$.next(details)))
  }

  buildUpgradeDetailPredicate(sourceDelegateVersion: number, targetDelegateVersion: number) {
    return (rd: ReleaseDetails) =>
      rd.sourceDelegateVersion > sourceDelegateVersion || rd.targetDelegateVersion > targetDelegateVersion
  }

  hasUpgradeDetails(sourceDelegateVersion: number, targetDelegateVersion: number): boolean {
    return this.releaseDetailsStore$.value?.some(
      this.buildUpgradeDetailPredicate(sourceDelegateVersion, targetDelegateVersion)
    )
  }

  upgradeDetails(sourceDelegateVersion: number, targetDelegateVersion: number): ReleaseDetails[] {
    return this.releaseDetailsStore$.value?.filter(
      this.buildUpgradeDetailPredicate(sourceDelegateVersion, targetDelegateVersion)
    )
  }
}
